<template>
  <b-modal id="cos-modal" title="Cost Of Sale Details" hide-footer no-close-on-backdrop @hidden="$emit('clearTransaction')">
    <b-card no-body v-if="transaction">
      <b-card-header>
        <h3 class="mb-0">{{ transaction.full_address }}</h3>
      </b-card-header>
      <b-card-body>
        <b-row class="mb-2">
          <b-col>
            <div v-if="admin">
              <h5><strong>CURRENT TEAM</strong></h5>
              <b-list-group size="sm">
                <b-list-group-item>
                  <b-row>
                    <b-col>
                      <strong>Name:</strong>
                    </b-col>
                    <b-col>
                      <strong>Commission:</strong>
                    </b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item v-for="(member, key) in transaction.members" :key="key">
                  <b-row>
                    <b-col>
                      {{ member.name }}
                    </b-col>
                    <b-col>
                      <span v-if="member.pivot.commission_type == 0">{{ (transaction.gci - transaction.referral_fees) * (member.pivot.amount / 100) | currency }}</span>
                      <span v-else>{{ member.pivot.amount | currency }}</span>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </div>
            <h5 class="mt-3"><strong>OTHER COST OF SALE</strong></h5>
            <b-list-group>
              <b-list-group-item>
                <b-row v-if="transaction.referral_fee == 1">
                  <b-col>
                    Referral Fee
                  </b-col>
                  <b-col>                  
                    <span>{{ transaction.referral_fees | currency }}</span>
                  </b-col>
                </b-row>
                <b-row v-if="transaction.broker_paid == 1">
                  <b-col>
                    Contribution Towards Broker
                  </b-col>
                  <b-col>                  
                    <span>{{ transaction.broker_fees | currency }}</span>
                  </b-col>
                </b-row>
                <b-row v-if="transaction.franchise_fee_paid == 1">
                  <b-col>
                    Franchise Fee
                  </b-col>
                  <b-col>
                    <span>{{ transaction.franchise_fees | currency }}</span>
                  </b-col>
                </b-row>
                <b-row v-if="transaction.other_cos">
                  <b-col>
                    Additional Cost of Sale
                  </b-col>
                  <b-col>
                    {{ transaction.other_cos | currency }}
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-modal>
</template>

<script>
export default {
  props: {
    transaction: null
  },
  computed: {
    admin() {
      return this.$store.getters['roles/admin'];
    }
  }
};
</script>